// components/RightSidebar.js
import React from "react";
import {
	FaFacebookF,
	FaInstagram,
	FaLinkedinIn,
	FaYoutube,
} from "react-icons/fa";
import { FaFacebook, FaLinkedin, FaXTwitter } from "react-icons/fa6"; // X (Twitter)

const RightSidebar = () => {
	const tags = [
		{ name: "Children's Health", count: 54 },
		{ name: "Coronavirus", count: 35 },
		{ name: "COVID-19 Diaries", count: 37 },
		{ name: "Disease", count: 579 },
		{ name: "Disease Management", count: 763 },
		{ name: "Allergy", count: 40 },
		{ name: "Anemia", count: 11 },
	];

	const recentPosts = [
		{
			title: "Cold vs. Flu: Spot the Difference and Know How to Fight Back!",
			date: "April 29, 2025",
			thumbnail: "/assets/blogs/covid-flu.png", // Corrected path
		},
		{
			title: "What You Need to Know About Medical Lab Tests",
			date: "April 25, 2025",
			thumbnail: "/assets/blogs/medical-lab.png", // Corrected path
		},
	];

	const socials = [
		{
			name: "X",
			text: "Follow me!",
			color: "bg-blue-500",
			icon: <FaXTwitter size={25} />,

			url: "https://x.com/LabsFine12756?t=_0qQyAiOCxlD_bgUUDMwHQ&s=09",
		},
		{
			name: "Facebook",
			text: "Follow me!",
			color: "bg-blue-600",
			icon: <FaFacebook size={25} />,
			url: "https://www.facebook.com/people/Fine-Labs/61574578554965/?rdid=kyZaCfmq3zC4oPnl&share_url=https%3A%2F%2Fwww.facebook.com%2Fshare%2F1Bj832sqyw%2F",
		},
		{
			name: "Instagram",
			text: "Our photos!",
			color: "bg-pink-500",
			icon: <FaInstagram size={25} />, // Add your icon here
			url: "https://www.instagram.com/finelabsmarketplace?igsh=OHdzZXBpbG5sZm13&utm_source=qr",
		},
		{
			name: "Linkedin",
			text: "Visit me!",
			color: "bg-blue-700",
			icon: <FaLinkedin size={25} />, // Add your icon here
			url: "https://www.linkedin.com/company/finelabsmarketplace/",
		},
	];
	return (
		<>
			{/* Tags */}
			{/* <div className='mb-8'>
				<h2 className='text-xl font-bold mb-4'>Tags</h2>
				<ul className='space-y-2'>
					{tags.map((tag, index) => (
						<li
							key={index}
							className='flex justify-between items-center border-b pb-1'>
							<span>{tag.name}</span>
							<span className='bg-orange-500 text-white text-xs font-semibold rounded-full px-2 py-0.5'>
								{tag.count}
							</span>
						</li>
					))}
				</ul>
			</div> */}

			{/* Recent Posts */}
			<div>
				<h2 className='text-xl font-bold mb-4'>Recent Posts</h2>
				<ul className='space-y-4'>
					{recentPosts.map((post, index) => (
						<li key={index} className='flex space-x-3'>
							<img
								src={post.thumbnail}
								alt={post.title}
								className='w-16 h-16 object-cover rounded'
							/>
							<div>
								<p className='text-sm font-medium'>{post.title}</p>
								<p className='text-xs text-gray-500'>{post.date}</p>
							</div>
						</li>
					))}
				</ul>
			</div>
			{/* Social Section */}
			<div className='mb-8'>
				<h2 className='text-xl font-bold mb-4'>
					Social<span className='text-teal-500'>.</span>
				</h2>
				<div className='space-y-2'>
					{socials.map((social, index) => (
						<div
							key={index}
							onClick={() => window.open(social.url, "_blank")}
							className={`flex justify-between items-center text-white px-4 py-3 rounded cursor-pointer transition-all duration-300 hover:scale-105 hover:shadow-lg ${social.color}`}>
							<div>
								<h3 className='font-bold text-lg'>{social.name}</h3>
								<p className='text-sm'>{social.text}</p>
							</div>
							<div>{social.icon}</div>
						</div>
					))}
				</div>
			</div>
		</>
	);
};

export default RightSidebar;
